import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Box } from 'reactjs-admin-lte'
import { Popover, OverlayTrigger, Modal, Button, ButtonToolbar, DropdownButton, MenuItem, ControlLabel, Label, InputGroup, FormGroup, Row, Col, FormControl } from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import FontAwesome from 'react-fontawesome'
import PODocStore from '../../stores/PODocStore'
import StockStore from '../../stores/StockStore'
// import PdfStore from '../../stores/PdfStore'
import WorkdocStore from '../../stores/WorkdocStore'
import SupplierPageModal from './SupplierPageModal'
import DatePicker from '../../component/element/DatePicker'
// import CkTimePicker from '../../component/element/CkTimePicker'
import ConfirmPopup from '../../component/element/ConfirmPopup'
import CKAutocomplete from '../../component/element/CKAutocomplete'
import AutopartStore from '../../stores/AutopartStore'
import SelectParts from './SelectParts'
import { Checkbox } from 'react-icheck';
import SearchCarButton from '../../component/element/SearchCarButton'
import IframeModal from '../../component/element/IframeModal'
import Lightbox from 'react-images-extended';
import POOutstandingRecordModal from './POOutstandingRecordModal'
import InputNumber from 'rc-input-number'
import Select from 'react-select'
import WorkDocAttachmentDoc from '../workdoc/WorkDocAttachmentDoc'
import './po.css'
import {connect} from 'react-redux'
import PaymentVoucherDoc from '../doc/PaymentVoucherDoc'
const NotificationSystem = require('react-notification-system');
const DEFAULT_ROW = 10
var numberFormat = require('number-format.js')

class PurchaseOrderDoc extends Component {

  constructor(...args) {
    super(...args)
    this.state = this.initState()
    this.pcInput = new Array(DEFAULT_ROW).fill('')
    this.car_info_timestmap =  Date.now()
  }

  initState(newState) {

    let state = {
      loading: false,
      showReportWorkHit: false,
      showReportWork: false,
      showSaveEror: false,
      showReceive: false,      
      
      poNo: '',
      show: false,
      shopName: '',
      rowBeep: -1,
      data: this.newEmptyRow(DEFAULT_ROW),
      
      options: [],
      doc: this.getEmptyDoc(),
      car_registration_no_list:[],
      car_info:'',
      validQty:null,
      due_date:'',                  
      discount_per:[],

      showPOR:false,
      showPOT:false,
      showPOE:false,
      showCar:false,
      showPOI:false,

      dataImg:{files:[]},
      currentImage: 0,
      lightboxIsOpen: false,
      images:[],

      aff_lists: [],
      checkSave:true,
      isPermApprovedDoc:true,
      approvedLimit:-1,
      po_config:{is_user_po_approved_doc:false},

      editReceived:false,
      editPayment:false,

      showWDA:false,
      imgPO:[],
      img_po_from_cat:''
    }

    if (newState !== undefined) {
      state = Object.assign(state, newState)
    }
    return state
  }

  componentDidMount() {
    // this.loadData(poNo)
    if (this.props.newDocModal) {
      this.loadNewDoc()
    }
  }

  
  renameDoc(newPoNo) {
    let { doc } = this.state
    doc['purchase_order_no'] = newPoNo
    this.setState({ poNo: newPoNo, doc: doc })
  }

  newEmptyRow(number) {
    return new Array(number).fill(null).map((item, index) => {
      return { unit:'', container_quantity:'', stock_container_unit:'', is_container:'0', stock_quantity_per_container_unit:'', unit_type:'unit', in_stock_quantity:'0', itemnum: '', productcode: '', detail: '', quantity: '', price_per_unit: '', amount: '', discount: '', vat:0, receiveditem_date:'', exportwork_date:'', import_stock_date:'', receiveditem_quantity:'', exportwork_quantity:'', import_stock_quantity:'' }
    })
  }

  getEmptyDoc() {
    return { discount:'',vat:'',vat_type:'VAT_EXCLUDE',seq_no:'',amount: 0, shop_name: '', shop_address: '', remark: '', status: '', credit_day: undefined,car_registration_no:'',approved_date:'',received_date:"",payment_date:"",exportwork_date:"",work_no:'',worklist:'' }
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  loadCarRegistrationNo(doc) {
    // let {car_registration_no_list} = this.state
    
    
    if(doc.car_registration_no!==undefined && doc.car_registration_no.length>=2 && (Date.now() - this.car_info_timestmap)>2000){
      WorkdocStore.loadCarRegistrationNoWithWork(doc.car_registration_no,(result)=> {
        let car = result.data.map((element,index) => {
          return Object.assign({id: element.Value,label: element.Name},element)
        });
        this.setState({car_registration_no_list:car})
        this.car_info_timestmap =  Date.now()
      })
    }
  }

  createNewPOWithoutReceivedItem(){
    let { doc,data } = this.state
    doc = Object.assign(doc,{seq_no:'',showCredit:false,stock_recordid:'',amount:0,remark:'',status:'0',payment_type:'CASH',credit_day:'0',approved_date:'',received_date:"",payment_date:"",exportwork_date:""})
    this.setState({ loading: true,doc:doc })
    PODocStore.newPODoc( (result)=> {
      data = data.reduce((rresult,item,index)=>{
        if(!item.is_receiveditem &&!item.is_importstock && !item.is_exportwork ){
          item.bf_purchase_order_item_id =''
          rresult.push(item)
        }
        return rresult
      },[])
      doc['purchase_order_no'] = result.data.doc.purchase_order_no
      doc['added_date'] = result.data.doc.added_date
      this.setState({ loading: false, poNo: result.data.doc.purchase_order_no, data: data },()=>{
        doc.vat = (doc.vat>0?doc.vat:this.getVat(this.getSumAmount()))
        doc.discount = (doc.discount?doc.discount:this.getDiscount())
        this.setState({doc:doc})
      })
    })
  }

  loadNewDoc(recordid,callback) {
    let { doc,po_config } = this.state
    
    this.setState(this.initState({ loading: true }))
    PODocStore.newPODoc( (result)=> {
      // let data = this.newEmptyRow(DEFAULT_ROW)
      // ReactDOM.findDOMNode(this.pcInput[0]).focus();
      // that.pcInput = new Array(data.length).fill('')

      doc = result.data.doc
      po_config = Object.assign(po_config,result.data.po_config)
      let data = [] 
      if (this.props.newDocModal&&this.props.itemList.length>0) {
        
        data = this.props.itemList.map((item,index)=>{
          return {container_quantity:'',stock_container_unit:'',is_container:'0',stock_quantity_per_container_unit:'',unit_type:'unit',in_stock_quantity:'0',amount:'',bf_purchase_order_item_id:'',detail:item.detail,itemnum:item.itemnum,part_type:'',price_per_unit:'',productcode:item.productCode,purchase_order_no:'',quantity:item.quantity,seq:''} // amount:item.amount,price_per_unit:item.pricePerUnit-item.discountAmount
        })
        data = data.concat(this.newEmptyRow(DEFAULT_ROW-data.length))
        let sum = 0
        data.forEach((item,index)=>{
          let amount = (item.amount===''?0:item.amount===null?0:item.amount===undefined?0:isNaN(item.amount)?0:item.amount)
          sum += parseFloat(amount)
        })
        doc.amount = sum

        if (doc.work_no===undefined)
            doc = Object.assign(doc, {work_no:this.props.workNo})
          else   
            doc.work_no =  this.props.workNo
          
          if (doc.worklist===undefined)
            doc = Object.assign(doc, {worklist:this.props.workNo})
          else   
            doc.worklist =  this.props.workNo

      } else {
        data = this.newEmptyRow(DEFAULT_ROW)
      }  
      ReactDOM.findDOMNode(this.pcInput[0]).focus();
      this.pcInput = new Array(data.length).fill('')

      if (recordid!==undefined&&recordid!==''){
        this.loadStockRecordDoc(recordid,(data,recordDoc)=>{
          doc = Object.assign(doc,recordDoc)
          this.setState({ loading: false,po_config:po_config, poNo: result.data.doc.purchase_order_no, doc: doc, data: data },()=>{
            doc.vat = (doc.vat>0?doc.vat:this.getVat(this.getSumAmount()))
            doc.discount = (doc.discount?doc.discount:this.getDiscount())
            this.setState({doc:doc},()=>{
              if (callback !== undefined) {
                callback(doc)
              }
            })
          })
        })
      }else{
        this.setState({ loading: false,po_config:po_config, poNo: result.data.doc.purchase_order_no, doc: result.data.doc, data: data },()=>{
          doc.vat = (doc.vat>0?doc.vat:this.getVat(this.getSumAmount()))
          doc.discount = this.getDiscount()
          this.setState({doc:doc},()=>{
            if (callback !== undefined) {
              callback(result.data.doc)
            }
          })
        })
      }
    })
  }

  loadStockRecordDoc(recordid,callback) {
    
    let {data} = this.state
    let doc = {shop_name:'',shop_address:'',shop_id:''}
    StockStore.loadRecordDoc(recordid, (result)=> {
      //console.log('result',result.data)
      data = []
      result.data.forEach(function(item,index) {
        if (item.header!==undefined) {
          doc.shop_name = item.header.shop_name
          doc.shop_address = item.header.shop_address
          doc.shop_id = item.header.shop_id
          doc.recordid = recordid          
        }

        let newData = item.itemlist.map((it,key)=>{
          
          return {
            detail: it.description,
            itemnum: it.itemnum,
            productcode: it.productcode,
            quantity: it.quantity,
            price_per_unit: '',
            amount: '',
            stock_type:it.stock_type,
            container_quantity:it.container_unit!==undefined?it.container_unit:'',            
            is_container:it.is_container!==undefined?it.is_container:'0',
            stock_container_unit:it.container_unit!==undefined?it.container_unit:'',
            stock_unit:it.unit!==undefined?it.unit:'',
            stock_quantity_per_container_unit:'',
            unit_type:it.unit_type!==undefined?it.unit_type:'unit',
            in_stock_quantity:it.in_stock_quantity!==undefined?it.in_stock_quantity:'',
            unit:it.unit!==undefined?it.unit:'',
            vat:0,
            discount:0
          }
        });
        data = data.concat(newData)
        
        doc.amount = ''      
       
      })
      callback(data,doc)
      //that.setState({data:data,doc:doc})
    })
  }

  loadData(poNo) {
    let {discount_per,po_config} = this.state
    let that = this
    this.setState(this.initState({ loading: true, poNo: poNo }))
    PODocStore.loadPODoc(poNo,  (result)=> {
      let data = result.data.itemlist
      po_config = Object.assign(po_config,result.data.po_config)
      data = data.map((item,index)=>{
        let unit_type = 'unit'
        if (item.unit===item.stock_container_unit)
          unit_type = 'container_unit'
        item = Object.assign(item,{unit_type:unit_type})
        return item
      })
      discount_per = data.map((item,index)=>{
        return item.discount_per
      })

      if (result.data.itemlist.length < DEFAULT_ROW) {
        data = data.concat(that.newEmptyRow(DEFAULT_ROW - result.data.itemlist.length))
      }
      if(data.length<=that.pcInput)
          ReactDOM.findDOMNode(that.pcInput[data.length]).focus();
      this.pcInput = new Array(data.length).fill('')

      let payment_type = false
      if (result.data.doc.payment_type==='CREDIT') {
        payment_type = true
      }
      this.loadFup('po',poNo)
      this.loadAffialiateList()
      let doc = result.data.doc
      this.setState({ loading: false,po_config:po_config,approvedLimit:result.data.approved_limit*1,isPermApprovedDoc:result.data.is_perm_approved_doc, doc: doc, data: data,car_info:result.data.doc.car_info, showCredit:payment_type, discount_per:discount_per },()=>{
        doc.vat = (doc.vat>0?doc.vat:this.getVat(this.getSumAmount()))
        doc.discount = (doc.discount?doc.discount:this.getDiscount())
        this.setState({doc:doc})
      })  
    })
  } 

  loadAffialiateList() {
    let {aff_lists} = this.state
    WorkdocStore.loadAffialiateList((result)=>{
      result.data.forEach(function(item,index) {
        aff_lists.push({
          value: item.affiliates_id,
          label: item.name
        })
      })
      this.setState({aff_lists:aff_lists})
    })
  }

  onPrintClick() {
    let { doc, data, poNo } = this.state

    // let that = this
    // this.setState({ loading: true })
    // let postData = { po: poNo, doc: doc, itemlist: data }
    // PODocStore.savePODoc(postData, function (result) {
    //   doc.seq_no = result.seq_no
    //   that.setState({ loading: false, doc: doc })
    //   if (process.env.NODE_ENV === "development") {
    //     window.open('https://demo2.bigfix.co/korat/pdf/?po=' + poNo + '&file=purchaseorder_doc', '_blank');
    //   } else {
    //     window.open('./pdf/?po=' + poNo + '&file=purchaseorder_doc', '_blank');
    //   }
    // }, function (error) {

    // })
    this.savePODoc(()=>{
      if (process.env.NODE_ENV === "development") {
        window.open('https://demo2.bigfix.co/korat/pdf/?po=' + poNo + '&file=purchaseorder_doc', '_blank');
      } else {
        window.open('./pdf/?po=' + poNo + '&file=purchaseorder_doc', '_blank');
      }
    })
  }

  onCustomerClick() {
    this.setState({ show: true })
  }

  onInputChange(key, e) {
    let { doc } = this.state
    doc[key] = e.target.value
    this.setState({ doc: doc })
  }

  onSupplierPageSelect(item) {
    let { doc } = this.state
    doc['shop_id'] = item.shop_id
    doc['shop_name'] = item.name
    doc['shop_address'] = item.address
    if(item.credit_day>0){
      doc['credit_day'] = item.credit_day
      doc['payment_type'] = 'CREDIT'
    }
    this.setState({ doc: doc })
  }

  /* onDateChange(value) {
    let { doc } = this.state
    doc['added_date'] = value
    this.setState({ doc: doc })
  } */

  onDateChange(dateString, dateMoment) {
    let { doc } = this.state
    doc['added_date'] = dateString
    this.setState({ doc: doc })
  }

  onSaveClick() {
    this.savePODoc()
  }

  savePODoc(completeSaveFunc){
    let { doc, data, poNo, checkSave } = this.state
    let {messages} = this.props
    if (checkSave) {
      this.setState({ loading: true, checkSave: false, validQty:null })
      if (this.state.showCredit){
        doc = Object.assign(doc,{credit_day:doc.credit_day===null?0:doc.credit_day,payment_type:'CREDIT'})
      }

      if (doc.vat_type===undefined)
        doc = Object.assign(doc,{vat_type:'NON_VAT'})
      
      // const sumAmt = this.getSumAmount()  
      const sumAmtN = this.getSumAmountNoDiscount()
      // doc.amount = this.getNetTotal(sumAmt)
      doc.amount = this.getNetTotal2()
      // doc.vat = this.getVat(sumAmt)
      doc.percent_vat = (100/doc.amount)*doc.vat
      doc.amount_before_vat = sumAmtN // doc.vat_type==='VAT_INCLUDE'?sumAmt-this.getVat(sumAmt):sumAmt
      let postData = { po: poNo, doc: doc, itemlist: data}
      PODocStore.savePODoc(postData,(result)=> {
        doc.seq_no = result.seq_no
        let i = 0
        data.forEach(function(item,index) {
          if (item.detail!=='') {
            if (item.bf_purchase_order_item_id===undefined)
              data[index] = Object.assign(data[index],{bf_purchase_order_item_id:result.itemlist[i].bf_purchase_order_item_id,is_exportwork:false,is_receiveditem:false,is_importstock:false,receiveditem_date:'',exportwork_date:'',import_stock_date:'',receiveditem_quantity:'',exportwork_quantity:'',import_stock_quantity:''})
            else
              data[index].bf_purchase_order_item_id = result.itemlist[i].bf_purchase_order_item_id
            
            i++  
          }
        })

        this.setState({ loading: false, doc: doc, data:data, checkSave:true })
        this.refs.notificationSystem.addNotification({
          title:messages['Notification'],
          message: messages['Automatic Saving'],
          level: 'info',
          position:'tc'
        });
        if(completeSaveFunc!==undefined){
          completeSaveFunc()
        }
        setTimeout(()=>{
          this.loadData(poNo)
        },1000)
      },(error)=> {
        this.setState({ loading: false, showSaveEror: true, checkSave:true })
      })
    }
  }

  onSaveErrorConfirm() {
    // console.log('onSaveErrorConfirm')
    this.onSaveClick()
  }

  onCloseClick() {

    if (this.props.onClose !== undefined) {
      this.props.onClose()
    }
  }

  onDeleteRowClick(index) {
    let { data } = this.state

    data.splice(index, 1);
    this.setState({ data: data })

  }

  updateValueData(index) {
    let { doc, data, discount_per } = this.state
    if (data[index]['quantity']==='-') {
      data[index]['quantity'] = '-'
    } else if (data[index]['quantity']===''||data[index]['quantity']===null||data[index]['quantity']===undefined||isNaN(data[index]['quantity'])) {
      data[index]['quantity'] = ''
    }

    if (data[index]['price_per_unit']===''||data[index]['price_per_unit']===null||data[index]['price_per_unit']===undefined||isNaN(data[index]['price_per_unit'])) {
      data[index]['price_per_unit'] = ''
    }
    if (data[index]['discount']===''||data[index]['discount']===null||data[index]['discount']===undefined||isNaN(data[index]['discount'])) {
      data[index]['discount'] = ''   
    }

    let qty = data[index]['quantity']
    if (qty==='-')
      qty = 0
    let pre_amount = (qty * data[index]['price_per_unit'])
    let invat_amount = (pre_amount*data[index]['vat']/100) + pre_amount
    data[index]['amount'] = invat_amount - data[index]['discount']
    
    doc['amount'] = 0
    data.forEach((item, index) => {
      doc['amount'] += item.amount * 1
    })

    if (data[index]['discount']>0&&data[index]['amount']>0) {
      let dis_per = 0
      
      if(data[index]['vat']*1===0)
        dis_per = (data[index]['discount']*100) / pre_amount
      else
        dis_per = (data[index]['discount']*100) / invat_amount
      discount_per[index] = dis_per.toFixed(2)
    } else {
      discount_per[index] = ''
    }
    this.setState({ doc: doc, data: data, discount_per:discount_per })
  }

  onFormChange(index, key, e) {
    let { doc, data, discount_per } = this.state
    let {messages} = this.props
    let value = ''
    if (key==='quantity'||key==='price_per_unit'||key==='discount') {
      value = e
    } else {
      value = e.target.value
    }

    if (key==='quantity') {
      if (data[index].receiveditem_date!==''&&data[index].receiveditem_date!==null&&data[index].receiveditem_date!==undefined&&value<data[index].receiveditem_quantity) {
        this.setState({validQty:index})
        this.refs.notificationSystem.addNotification({
          title:messages['Notification'],
          message: messages['Not Adjust Amount'],
          level: 'error',
          position:'tc'        
        });
        data[index][key] = value
        return false
      }
    }
    data[index][key] = value
    if (['quantity', 'price_per_unit'].includes(key)) {
      this.updateValueData(index)
    } else if (key==='discount') {
      if (value===''||value===null||value===undefined||isNaN(value))
        value = ''

      data[index][key] = value
      let pre_amount = (data[index]['quantity'] * data[index]['price_per_unit'])
      let invat_amount = (pre_amount*data[index]['vat']/100) + pre_amount      

      if (value>0&&invat_amount>0) {
        let dis_per = 0
        dis_per = (value*100) / invat_amount
        discount_per[index] = dis_per.toFixed(2)
      } else {
        discount_per[index] = ''
      }

      data[index]['amount'] = invat_amount - value
    } else if (key==='discount_per') {
      if (value===''||value===null||value===undefined||isNaN(value))
        value = ''

      discount_per[index] = value
      let dis = 0
      let pre_amount = (data[index]['quantity'] * data[index]['price_per_unit'])
      let invat_amount = (pre_amount*data[index]['vat']/100) + pre_amount      

      dis = (invat_amount*value) / 100
      data[index]['discount'] = dis.toFixed(2)
      data[index]['amount'] = invat_amount - data[index]['discount']
    }
    this.setState({ doc: doc, data: data, discount_per:discount_per },()=>{
      if (['quantity','price_per_unit','discount','discount_per'].includes(key)) {
        if (key==='discount'||key==='discount_per') {
          doc.discount = this.getDiscount()
          this.setState({doc:doc},()=>{
            doc.vat = this.getVat(this.getSumAmount())
            this.setState({doc:doc})
          })
        }
        let vat_type = {value:doc.vat_type}
        this.onVatTypeChange(vat_type)
      }    
    })
  }

  onRowAdd(number) {
    let { data } = this.state


    data = data.concat(this.newEmptyRow(number))

    this.pcInput = new Array(data.length).fill('')
    this.setState({ data: data })
  }


  onSearch(index, query) {
    let that = this
    //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadStockPartItemList(-1, query, function (result) {
      //console.log(result)
      //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      let options = result.data.map((item, index) => {
        return { 
          id: item.itemnum, 
          productCode: item.productcode, 
          itemnum: item.itemnum, 
          categoryName: item.cat_name, 
          detail: item.description, 
          pricePerUnit: 
          item.price_per_unit, 
          unit:item.unit, 
          stock_type:item.stock_type,
          container_quantity:item.container_quantity,
          container_unit:item.container_unit,
          is_container:item.is_container,
          quantity_per_container_unit:item.quantity_per_container_unit,
          quantity:item.quantity
        }
      })
      that.setState({ options: options })
    })

    //this.setState({options:options})
  }

  onTypeaheadInputChange(index,query){
    //console.log('typeChagne',e,text)
    //console.log("query",query)
    let {data} = this.state
    data[index]['detail'] = query
    
    
    this.setState({data:data})
  }

  onTypeaheadChange(index, option) {
    let { data } = this.state
    if (option.length === 1) {

      data[index].detail = option[0].detail
      data[index].quantity = 1
      data[index].unit = option[0].unit
      data[index].in_stock_quantity = option[0].quantity
      data[index].container_quantity = option[0].container_quantity
      data[index].stock_unit = option[0].unit
      data[index].stock_container_unit = option[0].container_unit
      data[index].is_container = option[0].is_container
      data[index].stock_quantity_per_container_unit = option[0].quantity_per_container_unit
      data[index].unit_type = 'unit'
      if (option[0].itemnum !== undefined) {
        data[index].itemnum = option[0].itemnum
        data[index].productcode = option[0].productCode
      }
    }
    this.setState({ data: data })
  }

  onSearchCarKeyPress(e) {
    if (e.charCode === 13) {
      //console.log('enter',e.target.value)
      let {doc} = this.state
      let that = this
      WorkdocStore.loadWorkdocCarInfo(e.target.value,function(result){
        let item = result.data     
        if(item.work_no!==''){   
          doc.work_no =  item.work_no         
          doc.car_registration_no = item.car_registration_no              
          that.setState({doc:doc,car_info:item.car_info})
        }else{
          doc.work_no = ''
          doc.car_registration_no = '';
          that.setState({doc:doc,car_info:that.props.messages['Car Registration Not Found']})
        }
      })
    }
  }


  onSearchKeyPress(index, key, target) {
    if (target.charCode === 13) {
      let { data } = this.state
      //console.log("code enter", data[index])
      let that = this, foundIndex = -1
      //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      this.setState({ loading: false })
      let productCode = data[index][key];
      data.forEach((item, iindex) => {
        if (item.productcode === productCode && iindex !== index) {
          foundIndex = iindex
        }
      })
      if (foundIndex >= 0) {
        data[foundIndex].quantity = data[foundIndex].quantity * 1 + 1
        data[index].productcode = ''
        that.setState({ loading: false, data: data, rowBeep: foundIndex })
        setTimeout(function () {
          that.setState({ rowBeep: -1 })
        }, 1500);
      } else {
        //AutopartStore.loadStockPartProductCode(productCode, function (result) {
        AutopartStore.loadStockProductCode('any',productCode,(result)=>{
          //console.log(result)
          //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
          if (result.data.length > 0) {
            let item = result.data[0]
            data[index].detail = item.description
            data[index].productcode = item.productcode
            data[index].unit = item.unit
            data[index].itemnum = item.itemnum
            data[index].quantity = 1
            data[index].stock_type = item.stock_type
            data[index].in_stock_quantity = item.quantity
            data[index].container_quantity = item.container_quantity
            data[index].stock_unit = item.unit
            data[index].stock_container_unit = item.container_unit
            data[index].is_container = item.is_container
            data[index].stock_quantity_per_container_unit = item.quantity_per_container_unit
            data[index].unit_type = 'unit'
            if (index === data.length - 1) {
              //End index
              data = data.concat(that.newEmptyRow(1))
              that.pcInput[index + 1] = ''
            }
            that.setState({ loading: false, data: data })
            ReactDOM.findDOMNode(that.pcInput[index + 1]).focus();
          } else {
            that.setState({ loading: false })
          }
        })
      }
    }
  }

  onWorkSearch() {
    this.setState({
      showReportWorkHit: true,
      showReportWork: this.state.doc.shop_id !== null
    })
  }

  onConfirmStockSave(){
    // let {poNo} = this.state
    // let that = this            
    this.setState({loading:true})
    // let postData = {po:poNo,status:'3'}


    this.setState({stockShow:false, stockMsgShowGW:false})
  
    // StockStore.requestStockIncrease(poNo,data,function(result){
    //   doc['status'] = '3'
    //   that.setState({loading:false,doc:doc})
    //   let url = './pdf/?sr=' + result.id + '&file=stockrecord_doc'
    //   if (process.env.NODE_ENV == "development") {
    //     url = 'https://demo2.bigfix.co/korat/pdf/?sr=' + result.id + '&file=stockrecord_doc'     
    //   }
    //   that.refs.iframe.loadUrl(url)       
    // },function(){
    //   //that.setState({loading:false})
    // })     
   
  }

  onSavePORecord(recordType,header){
    let {doc} = this.state
    if(recordType==='EXPORTWORK'){
      doc.exportwork_date = header.date
    }else if(recordType==='RECEIVED'){
      doc.received_date = header.date
    }else if(recordType==='IMPORT_STOCK'){
      doc.importstock_date = header.date
    }
    this.setState({doc:doc})
  }

  requestApprovedRequest(){
    let { poNo, doc } = this.state
    let {messages} = this.props
    this.setState({ loading: true })
    let postData = { po: poNo, status: '5',wo:doc.worklist }
    PODocStore.updatePODocStatus(postData,  (result)=> {
      doc['status'] = '5'
      this.setState({ loading: false, doc: doc })
      this.refs.notificationSystem.addNotification({
        title:messages['Notification'],
        message: messages['Submit PO']+' '+poNo+' '+messages['Successfully'],
        level: 'info',
        position:'tc'        
      });      
    })
  }
  

  onMenuItemSelect(index) {
    let { poNo, doc ,isPermApprovedDoc,approvedLimit} = this.state
    let {messages} = this.props
    if ('deletepo' === index) {
      //console.log('delete PO', poNo)
      this.setState({ loading: true })
      PODocStore.delPODoc(poNo,  (result)=> {
        this.setState({ loading: false })
        this.onCloseClick()
      })
    } else if ("approvestatus" === index) {
      if(isPermApprovedDoc){
        if(approvedLimit< 0 || doc.amount*1 <= approvedLimit ){
          this.setState({ loading: true })
          let postData = { po: poNo, status: '1',wo:doc.worklist }
          PODocStore.updatePODocStatus(postData,  (result)=> {
            doc['status'] = '1'
            this.setState({ loading: false, doc: doc })
          })
        }else{
          this.refs.notificationSystem.addNotification({
            title:messages['Notification'],
            message: messages['Not Permission Amount']+' '+doc.amount+' '+messages['Bath']+' '+messages['More Than Approved']+' '+approvedLimit+' '+messages['Bath'],
            level: 'error',
            position:'tc',
            action: {
              label: messages['Send To Approver'],
              callback: ()=> {
                //Request
                this.requestApprovedRequest()
              }
            }
          });          
        }
      }else{
        this.refs.notificationSystem.addNotification({
          title:messages['Notification'],
          message: messages['Not Permission'],
          level: 'error',
          position:'tc',
          action: {
            label: messages['Acknowledge']
          }
        });
      }
    } else if ("notapprovestatus" === index) {
      if(isPermApprovedDoc){
        if(approvedLimit< 0 || doc.amount*1 <= approvedLimit ){
          this.setState({ loading: true })
          let postData = { po: poNo, status: '6',wo:doc.worklist }
          PODocStore.updatePODocStatus(postData,  (result)=> {
            doc['status'] = '6'
            this.setState({ loading: false, doc: doc })
          })
        }else{
          this.refs.notificationSystem.addNotification({
            title:messages['Notification'],
            message: messages['Not Permission Amount']+' '+doc.amount+' '+messages['Bath']+' '+messages['More Than Approved']+' '+approvedLimit+' '+messages['Bath'],
            level: 'error',
            position:'tc',
            action: {
              label: messages['Send To Approver'],
              callback: ()=> {
                //Request
                this.requestApprovedRequest()
              }
            }
          });          
        }
      }else{
        this.refs.notificationSystem.addNotification({
          title:messages['Notification'],
          message: messages['Not Permission'],
          level: 'error',
          position:'tc',
          action: {
            label: messages['Acknowledge']
          }
        });
      }
    } else if ("receivestatus" === index) {
      this.setState({showPOR:true})      
    } else if ("returnstatus" === index) {
      this.setState({showPOT:true})      
    } else if ("exportworkstatus" === index) {  
      this.setState({showPOE:true})
    } else if ("importstock" === index) {      
      this.setState({showPOI: true })      
    } else if ("paidstatus" === index) {
        this.setState({loading:true})
        this.savePODoc(()=>{
          PODocStore.updatePODocPaymentStatus(poNo,(result) => {
            this.setState({loading:false})
            if (result.status==='OK') {
              this.refs.notificationSystem.addNotification({
                title:messages['Notification'],
                message: messages['Payment Status Adjustment'],
                level: 'info',
                position:'tc'
              });
              this.loadData(poNo)
            }
          },(result) => {
            //Status Fail
            this.setState({loading:false})
          })
        })        
    } else if ("credit" === index) {    
      this.setState({showCredit:true})
    } else if("createnoreceive"===index){
      this.createNewPOWithoutReceivedItem()
    } else if ("paymentvoucher"===index) {
      this.setState({showPaymentVoucher:true},()=>{
        this.savePODoc(()=>{
          this.refs.pvDoc.getWrappedInstance().loadPONewDoc(this.state.poNo)
        })  
      })
    }
  }

  getShopIdValidState() {
    if (this.state.showReportWorkHit && this.state.doc.shop_id === null) {
      return 'error'
    }

  }

  getValidationState() {
    // const length = this.state.shopName.length;
    // if (length > 10) return 'success';
    // else if (length > 5) return 'warning';
    // else if (length > 0) return 'error';
  }

  _renderMenuItemChildren(option, props, index) {
    let {messages} = this.props
    if (option.pricePerUnit > 0) {
      return (
        <div key={option.id}>
          <span>{option.detail} ({messages['Category']}{option.categoryName}) - {option.pricePerUnit} {messages['Bath']}</span>
        </div>
      );
    } else {
      return (
        <div key={option.id}>
          <span>{option.detail}</span>
        </div>
      );
    }
  }

  onTextChange(key,e) {
    let {doc} = this.state

    if (doc==="")
      return ''

    if (key==='credit') {
      doc.credit_day = e.target.value
      this.setState({doc:doc})
    } else {  
      doc[key] = e.target.value
      this.setState({doc:doc})
      if (key==='car_registration_no') {
        this.loadCarRegistrationNo(doc)
        if(e.target.value==='')
          this.setState({car_info:''})
      }
    }  
  }

  onTextSelect(key, e) { 
    let {doc,car_registration_no_list} = this.state
    if (doc==="")
      return ''
    
    if (key==='car_registration_no') {
      // let value = ''
      let car_info = ''
      
      car_registration_no_list.forEach(function(item,index) {
        if(e===item.label) {
          // value = item.id
          car_info = item.car_info
          // doc.work_no =  item.work_no
          // doc.worklist = item.work_no
          if (doc.work_no===undefined)
            doc = Object.assign(doc, {work_no:item.work_no})
          else   
            doc.work_no =  item.work_no
          
          if (doc.worklist===undefined)
            doc = Object.assign(doc, {worklist:item.work_no})
          else   
            doc.worklist =  item.work_no 
          doc[key] = item.car_registration_no  
        }  
      })

                
      doc.affiliates_id = ''
      this.setState({doc:doc,car_info:car_info})
    } else {
      if (key==='credit') {
        doc.credit_day = e
        this.setState({doc:doc})
      } else {
        doc[key] =  e
        this.setState({doc:doc})
      }  
    }
  }

  onCarSearchSelect(e,default_aff) {
    let {doc} = this.state
    let car_info = ''

    doc.work_no =  e.work_no
    doc.car_registration_no = (typeof e.car_registration_no!=='undefined'?e.car_registration_no:e.Value)
    car_info = e.car_info

    if (default_aff===''||default_aff===null||default_aff===undefined) {
      doc.affiliates_id = ''
      doc.worklist = e.work_no
    } else {
      doc.affiliates_id = default_aff
      doc.worklist = ''
    }

    this.setState({doc:doc,car_info:car_info})
  }

  onWorkClick(workNo){
    if (process.env.NODE_ENV === "development") {
      alert('show_work_doc:'+workNo)
    }else{
      if(window.show_work_doc!==undefined)
        window.show_work_doc(workNo)
    }
  }

  onAffChange(item) {
    // let {doc} = this.state
    // doc.affiliates_id = item
    // this.setState({doc:doc})
  }

  // onAffiliatesChange(e) {
  //   let {doc} = this.state
  //   doc.affiliates_id = e.value
  //   this.setState({doc:doc})
  // }

  // getDayFormat(value) {
  //   let _day = (value===''||value===null||value===undefined?'':value.substring(0, 10))
  //   let informat_day = ''
  //   if (_day!==''&&_day!==undefined) {
  //     let y = _day.substring(0,4)
  //     let m = _day.substring(5,7)
  //     let d = _day.substring(8,10)
  //     informat_day = d+'/'+m+'/'+((y*1)+543)
  //   }
  //   return informat_day
  // }

  getDayFormat(value) {
    let _day = (value===''||value===null||value===undefined?'':value.substring(0, 10))
    return _day
  }

  getTimeFormat(value) {
    let time = (value===''||value===null||value===undefined?'':value.substring(11))
    return time
  }

  // onOtherDateChange(field,value) {
  //   let {doc} = this.state
  //   if (value===''||value===null||value===undefined) {
  //     doc[field] = ''
  //     this.setState({doc:doc})
  //   } else {
  //     let y = value.substring(6)
  //     let m = value.substring(3,5)
  //     let d = value.substring(0,2)
  //     let date = (y-543)+'-'+m+'-'+d
  //     doc[field] = date+' '+this.getTimeFormat(doc[field])
  //     this.setState({doc:doc})
  //   }  
  // }

  onOtherDateChange(field,value) {
    let {doc} = this.state
    if (value===''||value===null||value===undefined) {
      doc[field] = ''
      this.setState({doc:doc})
    } else {
      doc[field] = value+' '+this.getTimeFormat(doc[field])
      this.setState({doc:doc})
    }  
  }

  // onOtherTimeChange(field,value) {
  //   let {doc} = this.state
  //   let date = this.getDayFormat(doc[field])
  //   doc[field] = date+' '+value
  //   this.setState({doc:doc})
  // }

  onDateEditClick(field) {
    let {editReceived,editPayment} = this.state
    if (field==='received_date') {
      if (editReceived)
      editReceived = false
      else
        editReceived = true
    } else if (field==='payment_date') {
      if (editPayment)
        editPayment = false
      else
        editPayment = true
    }
    this.setState({editReceived:editReceived,editPayment:editPayment})
  }

  renderOtherDate(value,field) {
    return(
      <DatePicker
        showFooter={true}
        popPlacement='bottom'
        value={value} 
        maxWidth={'100%'}
        inline={true}
        formG={'grid'}
        buddhistEra
        onChange={this.onOtherDateChange.bind(this,field)}
        readOnly={true}
      />
    )
  }

  // renderOtherTime(value,field) {
  //   return(
  //     <CkTimePicker
  //       maxWidth={'100%'}
  //       showIcon={true}
  //       inline={false}
  //       value={value}
  //       minuteStep={5}
  //       onTimeSaved={this.onOtherTimeChange.bind(this,field)}
  //     />
  //   )
  // }

  renderHeaderRow() {
    let {shop_name,shop_address,added_date, car_registration_no,approved_date,received_date,payment_date,exportwork_date,worklist,affiliates_id} = this.state.doc
    let {car_registration_no_list,editReceived,editPayment} = this.state
    let received_day = this.getDayFormat(received_date)
    let payment_day = this.getDayFormat(payment_date)
    // let received_time = this.getTimeFormat(received_date)
    // let payment_time = this.getTimeFormat(payment_date)
    if (typeof added_date === 'undefined') return null
    let {messages} = this.props
    return (
      <div>
        <Row>
          <Col md={3}>
            <FormGroup
              controlId="formBasicText"
              validationState={this.getShopIdValidState()}
            >
              <ControlLabel>{messages['Shop Name']} :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='user' /></InputGroup.Addon>
                <FormControl value={shop_name} onChange={this.onInputChange.bind(this, 'shop_name')} />
                <InputGroup.Addon onClick={this.onCustomerClick.bind(this)}><FontAwesome name='plus' /></InputGroup.Addon>
              </InputGroup>
            </FormGroup>
          </Col>
          <Col md={5}>
            <FormGroup
              controlId="formBasicText"
              validationState={this.getValidationState()}
            >
              <ControlLabel>{messages['Address']} :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='location-arrow' /></InputGroup.Addon>
                <FormControl value={shop_address} onChange={this.onInputChange.bind(this, 'shop_address')} />
              </InputGroup>
            </FormGroup>
          </Col>
          <Col md={2}>
            <FormGroup
              controlId="formBasicText"
              validationState={this.getValidationState()}
            >
              <ControlLabel>{messages['Date']} :&nbsp;</ControlLabel>
              <DatePicker style={{ display: 'inline-block' }}
                  ref={(ele) => { this.datePicker = ele }}
                  showIcon={true}
                  showFooter={true}
                  popPlacement='bottom'
                  buddhistEra
                  value={added_date}
                  onChange={this.onDateChange.bind(this)}
                  maxWidth={'100%'}
                />
            </FormGroup>
          </Col>
          <Col md={2} style={{display:this.state.showCredit?'':'none'}}>
            <FormGroup
              controlId="formBasicText"
              validationState={this.getValidationState()}
            >
              <ControlLabel>{messages['Credit']} :</ControlLabel>
              <CKAutocomplete
                        top={'-35px'}
                        items={[{label:'30',value:'30'},{label:'45',value:'45'},{label:'60',value:'60'},{label:'90',value:'90'}]}
                        value={this.state.doc.credit_day==null?'':this.state.doc.credit_day.toString()}
                        onChange={this.onTextChange.bind(this, 'credit')}
                        onSelect={this.onTextSelect.bind(this, 'credit')}
                        shouldItemRender={null}
                      />
            </FormGroup>
          </Col>
        </Row>
        <Row>
           <Col md={3}>
              <FormGroup
                controlId="formBasicText"                
              >
                <ControlLabel>{messages['Car Registration']} :</ControlLabel>
                <InputGroup>
                  <InputGroup.Addon><FontAwesome name='car'/></InputGroup.Addon>
                  <CKAutocomplete
                        items={car_registration_no_list}
                        value={car_registration_no!==null?car_registration_no:''}
                        onKeyPress={this.onSearchCarKeyPress.bind(this)}
                        onChange={this.onTextChange.bind(this, 'car_registration_no')}
                        onSelect={this.onTextSelect.bind(this, 'car_registration_no')}

                      />
                      <InputGroup.Addon className="btn" onClick={()=>this.setState({showCar:true})}>
                    <FontAwesome name='plus' />
                  </InputGroup.Addon>    
                </InputGroup>      
              </FormGroup>
            </Col>              
            <Col md={3}>
              <FormGroup>
                <ControlLabel>{messages['Model']}</ControlLabel>
                <InputGroup>
                  <h3 style={{margin:'0px'}}>
                    <Label bsStyle='default'>{this.state.car_info}</Label>
                  </h3>
                </InputGroup>
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <div style={{display:'inline-flex'}}>
                  <ControlLabel>{messages['Work No']}</ControlLabel>
                  <div style={{marginBottom:'5px'}} onClick={this.onWorkClick.bind(this,worklist)}>                    
                      <span style={{cursor:'pointer'}} className='label label-default'>{messages['Click']}</span>
                  </div>
                </div>
                <InputGroup>
                  <InputGroup.Addon><FontAwesome name='file-text' className='color-blue' /></InputGroup.Addon>
                  <FormControl value={worklist==null?'':worklist} readOnly={true} onChange={()=>{}} />
                </InputGroup>
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <ControlLabel>{messages['Affiliates']}</ControlLabel>
                {/* <Select
                  placeholder={'-- เลือกบริษัทในเครือ --'}
                  clearable={false}
                  options={aff_lists}
                  value={affiliates_id}
                  onChange={this.onAffiliatesChange.bind(this)}
                /> */}
                <FormControl value={affiliates_id==null?'':affiliates_id} readOnly={true} onChange={()=>{}} />
              </FormGroup>
            </Col>
            <Col md={2} style={{display:this.state.showCredit?'':'none'}}>
              <FormGroup>
                <ControlLabel>{messages['Due Date']}</ControlLabel>
                <FormControl readOnly={true} value={this.getDueDate()} onChange={()=>{}} />
              </FormGroup>
            </Col>
        </Row>
        <Row>
          <Col md={3}>
            <FormGroup
              controlId="formBasicText"
              validationState={null}
            >
              <ControlLabel>{messages['Approved Date']} :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='calendar'/></InputGroup.Addon>
                <FormControl value={approved_date} onChange={()=>{}} readOnly={true} />
              </InputGroup>            
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup
              controlId="formBasicText"
              validationState={null}
            >
              {/* <ControlLabel>วันรับของ :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='calendar'/></InputGroup.Addon>
                <FormControl value={received_date} onChange={()=>{}} readOnly={true} />
              </InputGroup> */}
              <ControlLabel>{messages['Received Date']} : <Button onClick={this.onDateEditClick.bind(this,'received_date')} className='btn btn-xs btn-default'><FontAwesome name='pencil' />&nbsp;{messages['Edit']}</Button></ControlLabel>
              {!editReceived?
              <InputGroup>
                <FormControl value={received_day} readOnly={true} />
                <InputGroup.Addon>
                  <FontAwesome name="calendar" />
                </InputGroup.Addon>
              </InputGroup> 
              :this.renderOtherDate(received_day,'received_date')}
            </FormGroup>
          </Col>
          {/* <Col md={2}>
            <FormGroup
              controlId="formBasicText"
              validationState={null}
            >
              <ControlLabel><br/></ControlLabel>    
              {!editReceived?
              <InputGroup>
                <FormControl value={received_time} readOnly={true} />
                <InputGroup.Addon>
                  <FontAwesome name="calendar" />
                </InputGroup.Addon>
              </InputGroup>
              :this.renderOtherTime(received_time,'received_date')}     
            </FormGroup>
          </Col> */}
          <Col md={3}>
            <FormGroup
              controlId="formBasicText"
              validationState={null}
            >
              <ControlLabel>{messages['Export Work Date']} :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='calendar'/></InputGroup.Addon>
                <FormControl value={exportwork_date} onChange={()=>{}} readOnly={true} />
              </InputGroup>            
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup
              controlId="formBasicText"
              validationState={null}
            >
              {/* <ControlLabel>ชำระเงินแล้วเมื่อ :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='calendar'/></InputGroup.Addon>
                <FormControl value={payment_date} onChange={()=>{}} readOnly={true} />
              </InputGroup> */}
              <ControlLabel>{messages['Payment Date']} : <Button onClick={this.onDateEditClick.bind(this,'payment_date')} className='btn btn-xs btn-default'><FontAwesome name='pencil' />&nbsp;{messages['Edit']}</Button></ControlLabel>
              {!editPayment?
              <InputGroup>
                <FormControl value={payment_day} readOnly={true} />
                <InputGroup.Addon>
                  <FontAwesome name="calendar" />
                </InputGroup.Addon>
              </InputGroup>
              :this.renderOtherDate(payment_day,'payment_date')}
            </FormGroup>
          </Col>
          {/* <Col md={2}>
            <FormGroup
              controlId="formBasicText"
              validationState={null}
            >
              <ControlLabel><br/></ControlLabel>    
              {!editPayment?
              <InputGroup>
                <FormControl value={payment_time} readOnly={true} />
                <InputGroup.Addon>
                  <FontAwesome name="calendar" />
                </InputGroup.Addon>
              </InputGroup>
              :this.renderOtherTime(payment_time,'payment_date')}     
            </FormGroup>
          </Col> */}
        </Row>
    </div>
    )
  }

  getDueDate() {
    let {doc} = this.state

    if (isNaN(doc.credit_day)||doc.credit_day==='0') {
      return ''
    }

    let added_date_y = doc.added_date.substring(6, 10)
    let added_date_m = doc.added_date.substring(3, 5)
    let added_date_d = doc.added_date.substring(0, 2)
    let added_date_new = added_date_y+'/'+added_date_m+'/'+added_date_d

    let date = new Date(added_date_new)
    let newdate = new Date(date)
    newdate.setDate(newdate.getDate() + ((doc.credit_day*1) + 1))
    
    let dd = newdate.getDate()
    let mm = (newdate.getMonth()*1) + 1
    let y = newdate.getFullYear()

    if (!isNaN(dd)&&!isNaN(mm)&&!isNaN(y)) {
      if (mm<10) {
        mm = '0'+mm
      }
      if (dd<10) {
        dd = '0'+dd
      }
      return dd+'/'+mm+'/'+y
    }
    return ''
  }

  renderRemark() {
    let { remark } = this.state.doc
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={3}>
          <FormGroup
            controlId="formBasicText"
            validationState={this.getValidationState()}
          >
            <ControlLabel>{this.props.messages['Note']}</ControlLabel>
              <FormControl value={remark} componentClass="textarea" style={{ width: '100%', height: '150px' }} onChange={this.onInputChange.bind(this, 'remark')} />
          </FormGroup>
        </Col>
        <Col md={9}>
          <Row>
            {this.renderImgZone()}
          </Row>  
        </Col>  
      </Row>
    )
  }

  getRowClassName(item, index) {
    let { rowBeep } = this.state
    let className = (item.itemnum > 0) ? '' : (item.detail.length > 0) ? 'bg-gray' : ''

    if (rowBeep === index) {
      className = 'bg-yellow'
    }
    return className
  }

  renderWorkNo(workNo) {
    let {messages} = this.props
    if (typeof workNo === 'undefined' || workNo === '') return null
    const title = messages['Work No']+' ' + workNo
    const popoverRight = (
      <Popover id="popover-trigger-hover-focus" title={title}>
        <strong>{messages['Click Icon To View Worksheet']}</strong>
      </Popover>
    )
    return (
      <span>
        {workNo + ' '}
        <OverlayTrigger
          trigger={['hover', 'focus']}
          placement="right"
          overlay={popoverRight}
        >
          <FontAwesome className="text-blue" name='file-text-o' />
        </OverlayTrigger>
      </span>
    )
  }

  renderPartType(part_type){
    let {messages} = this.props
    const partTypeMap = {originalPrice:messages['Original'],similarPrice:messages['Similar'],oldPartPrice:messages['Old']}

    return partTypeMap[part_type]
  }

  onDiscountPercentSelect(index,key,e) {
    let {discount_per,data} = this.state
    // if (e===''||e===null||e===undefined||isNaN(e))
    //     e = 0

    discount_per[index] = e
    let dis = 0
    let amount = data[index]['quantity']*data[index]['price_per_unit']

    
    amount = (amount*data[index]['vat']/100) + amount
    

    dis = (amount*e) / 100
    data[index]['discount'] = dis.toFixed(2)
    data[index]['amount'] = amount - data[index]['discount']
    this.setState({discount_per:discount_per,data:data})
  }

  onColVatChange(index){
    let {data,doc} = this.state
    
    if(data[index]['vat']*1===0)
      data[index]['vat'] = 7
    else
      data[index]['vat'] = 0

    this.updateValueData(index)  
    this.setState({data:data},()=>{
      let vat_type = {value:doc.vat_type}
      this.onVatTypeChange(vat_type)
    })
  }

  onUnitChange(index,e) {
    let {data} = this.state
    data[index].unit_type = e.value
    if (e.value==='unit')
      data[index].unit = data[index].stock_unit
    else
      data[index].unit = data[index].stock_container_unit
    this.setState({data:data})
  }

  renderRowData() {
    let { data, options, discount_per, doc, validQty } = this.state
    let {messages} = this.props
    return(
      data.map((item, index) => { 
        let qty = item.in_stock_quantity
        if (item.is_container==='1') {
          if (item.unit_type==='unit') {
            qty = (item.in_stock_quantity===''||item.in_stock_quantity===null||item.in_stock_quantity===undefined||isNaN(item.in_stock_quantity)?0:item.in_stock_quantity)
          } else {
            let _qty = (item.in_stock_quantity===''||item.in_stock_quantity===null||item.in_stock_quantity===undefined||isNaN(item.in_stock_quantity)?0:item.in_stock_quantity)
            let _qty_per_container_unit = (item.stock_quantity_per_container_unit===''||item.stock_quantity_per_container_unit===null||item.stock_quantity_per_container_unit===undefined||isNaN(item.stock_quantity_per_container_unit)?0:item.stock_quantity_per_container_unit)
            qty = _qty/_qty_per_container_unit
          }
          qty = this.getNumberFormat(qty)
        }
        return(
          <tr key={index} className={this.getRowClassName(item, index)}>
            <td className='text-center'>{index + 1}</td>
            <td className='data-column'>
              <FormControl
                disabled={doc.payment_date!==''?true:false}
                ref={(input) => { this.pcInput[index] = input; }}
                value={item.productcode}
                onChange={this.onFormChange.bind(this, index, 'productcode')}
                onKeyPress={this.onSearchKeyPress.bind(this, index, 'productcode')} />
            </td>
            <td className='data-column'>
              <AsyncTypeahead
                disabled={doc.payment_date!==''?true:false}
                allowNew={true}
                multiple={false}
                newSelectionPrefix={messages['Add New Item']+' : '}
                promptText={messages['Keypress For Searching']}
                searchText={messages['Searching']}
                selected={[{ detail: item.detail }]}
                options={options}
                labelKey="detail"
                onSearch={this.onSearch.bind(this, index)}
                onChange={this.onTypeaheadChange.bind(this, index)}
                onInputChange={this.onTypeaheadInputChange.bind(this,index)}
                placeholder=""
                renderMenuItemChildren={this._renderMenuItemChildren.bind(this)}
              />
            </td>
            <td className='text-center'>{this.renderPartType(item.part_type)}</td>
            <td className='data-column text-center'>
              <InputNumber
                disabled={doc.payment_date!==''?true:false}
                className={'input-number-format text-center'+(validQty===index?' has-error':'')}
                value={item.quantity} 
                onChange={this.onFormChange.bind(this, index, 'quantity')}
                formatter={value =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
              />
            </td>
            <td className='text-center'>
              {item.is_container==='1'&&(item.itemnum!==''&&item.itemnum!==undefined&&item.itemnum!==null)?
                  <Select
                    clearable={false}
                    options={[{label:(item.stock_unit===''?'-':item.stock_unit)+' (หน่วยย่อย)',value:'unit'},{label:(item.stock_container_unit===''?'-':item.stock_container_unit)+' (หน่วยใหญ่)',value:'container_unit'}]}
                    value={item.unit_type}
                    onChange={this.onUnitChange.bind(this,index)}
                  />
              :<FormControl disabled={doc.payment_date!==''?true:false} className='text-center' value={item.unit} onChange={this.onFormChange.bind(this, index, 'unit')} />}
            </td>  
            <td className='data-column text-right'>
              <InputNumber
                disabled={doc.payment_date!==''?true:false}
                className='input-number-format text-right'
                value={item.price_per_unit} 
                onChange={this.onFormChange.bind(this, index, 'price_per_unit')}
                formatter={value =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
              />
            </td>
            <td className='data-column text-center'>
              <Checkbox
                      disabled={doc.payment_date!==''?true:false}
                      onChange={this.onColVatChange.bind(this,index)}
                      checked={item.vat>0}
                      checkboxClass="icheckbox_square-blue"
                      increaseArea="20%"                  
                    /> 
            </td>
            <td className='data-column text-right'>
              <CKAutocomplete
                            disabled={doc.payment_date!==''?true:false}
                            textAlign='text-right'
                            top={'-35px'}
                            items={[{label:'0',value:'0'},{label:'2',value:'2'},{label:'5',value:'5'},{label:'10',value:'10'},{label:'15',value:'15'},{label:'20',value:'20'},{label:'25',value:'25'}]}
                            value={discount_per[index]}
                            onChange={this.onFormChange.bind(this, index, 'discount_per')}
                            onSelect={this.onDiscountPercentSelect.bind(this, index, 'discount_per')}
                          />
            </td>
            <td className='data-column text-right'>
              <InputNumber
                disabled={doc.payment_date!==''?true:false}
                className='input-number-format text-right'
                value={item.discount} 
                onChange={this.onFormChange.bind(this, index, 'discount')}
                formatter={value =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
              />
            </td>
            <td className='data-column text-right'>{item.amount!==''?numberFormat("#,##0.##",item.amount):''}</td>
            <td className='data-column text-center' style={{verticalAlign:'middle'}}>{qty}</td>
            <td className='text-center'>{this.renderWorkNo(item.work_no)}</td>
            <td className='text-center'>{item.car_registration_no}</td>
            <td className='text-center'>{item.car_detail}</td>
            <td className='text-center'>{item.receiveditem_quantity}</td>
            <td className='text-center'>{item.receiveditem_date}</td>
            <td className='text-center'>{item.exportwork_quantity}</td>
            <td className='text-center'>{item.exportwork_date}</td>
            <td className='text-center'>{item.import_stock_quantity}</td>
            <td className='text-center'>{item.import_stock_date}</td>
            <td className='text-center'><Button bsStyle={'danger'} style={{display:(item.is_receiveditem||item.is_exportwork?'none':'')}} onClick={this.onDeleteRowClick.bind(this, index)}><FontAwesome name='eraser' /></Button></td>
          </tr>
        )
      })
    )
  }

  getDiscount(){
    let {data,doc} = this.state
    let sum = 0
    
    data.forEach(function(item,index) { 
      let value = item.discount
      if (value===''||value===null||value===undefined||isNaN(value)) 
        value = 0 
      
      sum = parseFloat(value) + parseFloat(sum)
    })
    return sum.toFixed(2)
  }

  getSumAmount() {
    // let {data} = this.state
    // let sum = 0
    // data.forEach(function(item,index) { 
    //   let value = item.amount
    //   if (value===''||value===null||value===undefined||isNaN(value)) 
    //     value = 0 
      
    //   sum = parseFloat(value) + parseFloat(sum)
    // })
    // return sum.toFixed(2)

    let {doc} = this.state
    let sum = 0
    sum = this.getSumAmountNoDiscount()-(doc.discount?doc.discount:this.getDiscount())
    return sum
  }

  getSumAmountNoDiscount() {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) { 
      let price_per_unit = item.price_per_unit
      if (price_per_unit===''||price_per_unit===null||price_per_unit===undefined||isNaN(price_per_unit)) 
        price_per_unit = 0
      let quantity = item.quantity
      if (quantity===''||quantity===null||quantity===undefined||isNaN(quantity)) 
        quantity = 0   
      
      let vat = 0
      if (item.vat>0) {
        vat = ((price_per_unit*quantity)*7)/100
      }  
      sum += (price_per_unit*quantity)+(vat*1)
    })
    return sum.toFixed(2)
  }

  getVat(sumAmt) {
    let {doc} = this.state
    let sum = 0
    if (doc.vat_type==='VAT_EXCLUDE')
      sum = (sumAmt*7)/100
    else if (doc.vat_type==='VAT_INCLUDE')
      sum = sumAmt-(sumAmt/1.07)
    else
      sum = 0
    return sum.toFixed(2)
  }

  getNetTotal(sumAmt) {
    let sum = 0
    sum = parseFloat(sumAmt) + parseFloat(this.getVat(sumAmt))
    return sum.toFixed(2)
  }

  getNetTotal2() {
    let {doc} = this.state
    let sum = 0
    // let sumAmt = this.getSumAmount()
    let sumAmt = this.getSumAmountNoDiscount()-(doc.discount?doc.discount:this.getDiscount())
    let vat = doc.vat // this.getVat(sumAmt)
    if (doc.vat_type==='VAT_INCLUDE') {
      sumAmt = sumAmt-vat
    }
    sum = (vat*1)+(sumAmt*1)
    return sum
  }

  // onVatChange(value) {
  //   let {doc} = this.state
  //   if (value==='NON_VAT'||value===undefined)
  //     doc.vat_type = 'VAT_EXCLUDE'
  //   else
  //     doc.vat_type = 'NON_VAT'  
    
  //   this.setState({doc:doc})
  // }

  onVatChange(e) {
    let {doc} = this.state
    doc.vat = e.target.value
    this.setState({doc:doc})
  }

  onVatTypeChange(e) {
    let {doc} = this.state
    doc.vat_type = e.value
    this.setState({doc:doc},()=>{
      let sumAmt = this.getSumAmount()
      doc.vat = this.getVat(sumAmt) 
      this.setState({doc:doc})
    })
  }

  onDiscountChange(e) {
    let {doc,data} = this.state
    let {messages} = this.props
    let hasDiscountTb = false
    data.forEach((item,index)=>{
      if (item.discount>0)
        hasDiscountTb = true
    })
    if (!hasDiscountTb) {
      doc.discount = (e.target.value===null||e.target.value===undefined||isNaN(e.target.value)?'':e.target.value)
      this.setState({doc:doc},()=>{
        let sumAmt = this.getSumAmount()
        doc.vat = this.getVat(sumAmt) 
        this.setState({doc:doc})
      })
    } else {
      this.refs.notificationSystem.addNotification({
        title:messages['Notification'],
        message:'ท่านได้ใส่ข้อมูลส่วนลดในตาราง เรียบร้อยแล้ว ถ้าต้องการแก้ไขข้อมูล ให้ลบส่วนลดในตาราง',
        level:'error',
        position:'tc'        
      });
    }  
  }

  onUploadClick(e) { 
    let {poNo} = this.state
    let url = ''
    if (process.env.NODE_ENV === "development") {
      url = 'https://demo2.bigfix.co/korat/fup/po.html?po='+poNo
    } else {
      url = './fup/po.html?po='+poNo
    }
    this.onWDAHide()
    this.refs.iframeUpload.loadUrl(url)
  }

  loadFup(cat,work_no) {
    let {poNo} = this.state
    PODocStore.loadFup(poNo,cat,(result)=>{
      this.setState({dataImg:result.data})
    })
  }

  onUpImgHide(e) {
    let {poNo} = this.state
    this.loadFup('po',poNo)
  }

  onImgClick(index,e) {
    let {images,dataImg} = this.state
    dataImg.files.forEach(element => {
      images.push({
        src: element.url,
        thumbnail: element.thumbnailUrl,
        srcset: [
          element.url,
        ],
        caption: element.name
      })
    })  
    
    this.setState({
      currentImage: index,
      lightboxIsOpen: true,
      images:images
    });
  }

  onClickImage() {
    let {dataImg} = this.state
    if (this.state.currentImage === 0) {
      this.onClickNext()
    } else if (this.state.currentImage === dataImg.files.length-1) {
      this.onClickPrevious()
    }  
  }

  onClickNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  onClickPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }

  onCloseLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
      images:[]
    });
  }

  onWDAOpen() {
    this.setState({showWDA:true})
  }

  onWDAHide() {
    this.setState({showWDA:false})
  }

  onAddPO() {
    let {imgPO,img_po_from_cat,doc,poNo} = this.state
    let {messages} = this.props
    if (imgPO.length>0) {
      let postData = {wo:doc.worklist,to_po:poNo,from_cat:img_po_from_cat,files:imgPO}
      WorkdocStore.saveAttachmentCopyToPo(postData,(result)=>{
        if (result.status==='OK') {
          this.refs.notificationSystem.addNotification({
            title:messages['Notification'],
            message: 'เลือกรูปเข้าไปในใบสั่งซื้อสำเร็จ',
            level: 'info',
            position:'tc'        
          });
          this.savePODoc(()=>{
            this.onWDAHide()
          })
        }
      },()=>{
        this.onWDAHide()
        this.refs.notificationSystem.addNotification({
          title:messages['Notification'],
          message: 'เลือกรูปเข้าไปในใบสั่งซื้อไม่สำเร็จ',
          level: 'error',
          position:'tc'        
        });
      })
    }
  }

  renderTable() {
    let { doc } = this.state
    let {messages} = this.props
    const discount = doc.discount // this.getDiscount()
    // const sumAmt = this.getSumAmount()
    const sumAmtN = this.getSumAmountNoDiscount()
    // const beforeDiscount = (sumAmt*1)+(discount*1)
    // const vat = this.getVat(sumAmt)
    // const netTotal = this.getNetTotal(sumAmt)

    return (
      <div className='display-overflow'>
        <table className='table table-responsive table-hover table-bordered-solid' style={{ minWidth: '2590px' }}>
          <thead>
            <tr>
              <th rowSpan={2} className='text-center' style={{ width: '30px' }}>{messages['Number']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '150px' }}>{messages['Product Code']}</th>
              <th rowSpan={2} style={{ minWidth: '350px' }}>{messages['Item']}</th>
              <th rowSpan={2} className='text-center'>{messages['Type']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '120px' }}>{messages['Quantity']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '130px' }}>{messages['Unit']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '125px' }}>{messages['Price/Unit']}</th>              
              <th rowSpan={2} className='text-center' style={{ width: '90px' }}>{messages['VAT']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '100px' }}>{messages['Discount Percent']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '125px' }}>{messages['Discount']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '125px' }}>{messages['Amount']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '100px' }}>จำนวนในคลัง</th>
              <th colSpan={3} className='text-center'>{messages['Job No/Work No']}</th>
              <th colSpan={2} className='text-center'>{messages['Received']}</th>
              <th colSpan={2} className='text-center'>{messages['Pickup']}</th>
              <th colSpan={2} className='text-center'>{messages['Import Stock']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '30px' }}>{messages['Delete']}</th>
            </tr>
            <tr>
              <th className='text-center' style={{width:'150px'}}>{messages['Work No']}</th>
              <th className='text-center' style={{width:'150px'}}>{messages['Car Registration']}</th>
              <th className='text-center' style={{width:'150px'}}>{messages['Model']}</th>
              <th className='text-center' style={{width:'100px'}}>{messages['Quantity']}</th>
              <th className='text-center' style={{width:'120px'}}>{messages['Date']}</th>
              <th className='text-center' style={{width:'100px'}}>{messages['Quantity']}</th>
              <th className='text-center' style={{width:'120px'}}>{messages['Date']}</th>
              <th className='text-center' style={{width:'100px'}}>{messages['Quantity']}</th>
              <th className='text-center' style={{width:'120px'}}>{messages['Date']}</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={10} className='text-right'>{messages['Amount Before Discount']}</th>
              <th className='text-right'>{numberFormat("#,##0.00",sumAmtN)}</th>
              <th colSpan={11} className='text-right'></th>
            </tr>
            <tr>
              <th colSpan={10} className='text-right' style={{verticalAlign:'middle'}}>{messages['Discount']}</th>
              {/* <th className='text-right'>{numberFormat("#,##0.00",discount)}</th> */}
              <th className='text-right'>
                <FormControl
                  ref='inputVat'
                  className={'text-right'}
                  value={doc.discount} 
                  onChange={this.onDiscountChange.bind(this)}
                />
              </th>
              <th colSpan={11} className='text-right'></th>
            </tr>
            <tr>
              <th colSpan={10} className='text-right'>{messages['Total Amount']}</th>
              {/* <th className='text-right'>{numberFormat("#,##0.00",sumAmt)}</th> */}
              {/* <th className='text-right'>{doc.vat_type==='VAT_INCLUDE'?numberFormat("#,##0.00",(sumAmtN-discount)-this.getVat(sumAmtN-discount)):numberFormat("#,##0.00",sumAmtN-discount)}</th> */}
              <th className='text-right'>{doc.vat_type==='VAT_INCLUDE'?(numberFormat("#,##0.00",(sumAmtN-discount)-doc.vat)?numberFormat("#,##0.00",(sumAmtN-discount)-doc.vat):'0.00'):numberFormat("#,##0.00",sumAmtN-discount)}</th>
              <th colSpan={11} className='text-right'></th>
            </tr>
            <tr>
              <th colSpan={10} className='text-right'>
                {/* <Checkbox
                  onChange={this.onVatChange.bind(this,doc.vat_type)}
                  checked={doc.vat_type==='NON_VAT'||doc.vat_type===undefined?false:true}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label={' '+messages['Vat 7%']}
                >
                </Checkbox> */}
                <span style={{position:'relative',top:'8px'}}>{messages['Vat 7%']}</span>
                &nbsp;
                <span className='text-left'>
                  <Select
                    className='pull-right'
                    style={{width:'100px'}}
                    clearable={false}
                    options={[
                      {label:'ไม่มีภาษี',value:'NON_VAT'},
                      {label:'Vat ใน',value:'VAT_INCLUDE'},
                      {label:'Vat นอก',value:'VAT_EXCLUDE'}
                    ]}
                    value={doc.vat_type}
                    onChange={this.onVatTypeChange.bind(this)}
                  />
                </span>
              </th>
              <th className='text-right'>
                {/* {numberFormat("#,##0.00",vat)} */}
                <FormControl
                  disabled={doc.vat_type==='NON_VAT'?true:false}
                  ref='inputVat'
                  className={'text-right'}
                  value={doc.vat} 
                  onChange={this.onVatChange.bind(this)}
                />
              </th>
              <th colSpan={11} className='text-right'></th>
            </tr>
            <tr>
              <th colSpan={10} className='text-right'>{messages['Total']}</th>
              <th className='text-right'>
                {/* {numberFormat("#,##0.00",netTotal)} */}
                {this.getNumberFormat(this.getNetTotal2())}
              </th>
              <th colSpan={11} className='text-right'></th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  renderNewItemButton() {
    let {messages} = this.props
    let {doc} = this.state
    return (
      <div style={{ display: 'inline-flex' }}>
        <ButtonToolbar>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this, 1)}><FontAwesome name='plus' />&nbsp;{messages['Add Item']}</Button>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this, 10)}><FontAwesome name='plus' />&nbsp;{messages['Add 10 Item']}</Button>
          <Button 
            className='btn btn-primary' 
            onClick={doc.worklist!==''&&doc.worklist!==null&&doc.worklist!==undefined?this.onWDAOpen.bind(this):this.onUploadClick.bind(this)}
          >
            <FontAwesome name='file-image-o'/>&nbsp;{messages['Image File']}
          </Button>
          <Button className='bg-orange' onClick={this.onWorkSearch.bind(this)}><FontAwesome name='search' />&nbsp;{messages['Search From Car']}</Button>
        </ButtonToolbar>
        <div className="text-center bg-gray " style={{ width: '300px', marginLeft: '15px' }}>{messages['Bar Color']}</div>
      </div>
    )
  }

  renderStatus() {
    let { doc } = this.state
    let {messages} = this.props
    if (doc.status === '0' ) {
      if(doc.seq_no>0){
        return (<span />)
      }else{
        return (<span className='label label-default'>{messages['Start Create PO']}</span>)
      }
    } else if (doc.status === '1') {
      return (<span className='label label-success'>{messages['Approved']}</span>)
    } else if (doc.status === '2') {
      return (<span className='label label-primary'>{messages['Recieved']}</span>)
    } else if (doc.status==='3') {
      return (<span className="label label-success" >{messages['Imported Stock']}</span>)
    } else if (doc.status==='4') {
      return (<span className="label label-success" >{messages['Export Work']}</span>)       
    } else if (doc.status==='5') {
      return (<span className="label label-success" >{messages['Approving']}</span>)           
    } else if (doc.status==='6') {
      return (<span className="label label-danger" >{messages['Not Approval']}</span>)           
    } else {
      return (<span />)
    }
  }

  renderPaymentStatus() {
    let { doc } = this.state
    if (doc.payment_date!=='') {
      return (<span className="label label-success" ><FontAwesome name='money' />&nbsp;{this.props.messages['Already Paid']}</span>)        
    }
  }

  closeReportWorkModal() {
    this.setState({ showReportWork: false })
  }

  onRowWorkClick(workNo) {
    /* const dataAPI = {
      "data":
      [{
        "bf_work_damage_id": "1025",
        "work_no": "SR304.0685\/2560",
        "seq": "4", "wage_itemnum": "0",
        "itemnum": "828",
        "detail": "\u0e01\u0e23\u0e30\u0e08\u0e01\u0e21\u0e2d\u0e07\u0e2b\u0e25\u0e31\u0e07 \u0e2b\u0e49\u0e2d\u0e07\u0e42\u0e14\u0e22\u0e2a\u0e32\u0e23",
        "quantity": "1",
        "price_per_unit": "0",
        "paint_flag": "0",
        "fix_flag": "0",
        "part_flag": "1",
        "stock_flag": "0",
        "export_stock_flag": "0",
        "wait_insurer_flag": "0",
        "wage_cost": "0",
        "part_cost": "0",
        "price_on_shop": [],
        "part_from": "shop_3:similarPrice",
        "row_style": "",
        "added_date": "2017-10-05 11:40:03",
        "added_by": "ckthink@kkc"
      }]
    } */
    this.setState({ showReportWork: false })
    if (typeof this.state.doc.shop_id === 'undefined' && typeof workNo === 'undefined')
      return

    const shop_id = this.state.doc.shop_id
    WorkdocStore.loadPurchaseSupplier(workNo, shop_id, (result) => {
      const newData = [...this.state.data]
      const emptyEleIndex =
        this.state.data.findIndex((ele) =>
          (ele.quantity === '' || ele.quantity === '0' || ele.quantity === 0)
        )
      const keys = [
        'detail',
        'itemnum',
        'productcode',
        'quantity',
        'bf_work_damage_id'
      ]
      result.data.forEach((ele, index) => {
        keys.forEach((key) =>
          newData[emptyEleIndex + index][key] =
          (typeof ele[key] !== 'undefined' && ele[key] !== null)
            ? ele[key]
            : ''
        )
      })

      this.setState({
        data: newData
      })
    })
  }

  onSavePartItemsClick(newPurChaseOrders) {
    let {doc} = this.state
    newPurChaseOrders.forEach(function(item,index) {
      if (item.amount===undefined)
        newPurChaseOrders[index] = Object.assign(newPurChaseOrders[index],{amount:0})
      if (item.vat===undefined)
        newPurChaseOrders[index] = Object.assign(newPurChaseOrders[index],{vat:0})
    })

    const numRow = 10
    const difNumRow = numRow - newPurChaseOrders.length
    if (difNumRow > 0) {
      const emptyItems = this.newEmptyRow(difNumRow)
      this.setState({
        showReportWork: false,
        data: newPurChaseOrders.concat(emptyItems)
      })
    } else {
      this.setState({
        showReportWork: false,
        data: newPurChaseOrders
      })
    }

    newPurChaseOrders.forEach(function(item,index) {
      doc.car_registration_no = item.car_registration_no
    })
    let car = []
    WorkdocStore.loadCarRegistrationNo(doc.car_registration_no,(result)=>{
      let car_info = ''
      result.data.forEach(function(item,index) {
        car.push({
          id: item.Value,
          label: item.Name,
          car_info: item.car_info,
          work_no :item.work_no
        })

        if (item.Value===doc.car_registration_no)
          car_info = item.car_info
      })
      this.car_info_timestmap =  Date.now()
      let checkWorkNo = []
      newPurChaseOrders.forEach((item,index)=>{
        if (checkWorkNo.indexOf(item.work_no)===-1)
          checkWorkNo.push(item.work_no)
      })

      if (checkWorkNo.length===1)
        doc.worklist = checkWorkNo[0]
      
      this.setState({car_info:car_info,doc:doc,car:car})
    })
  }

  onAfterReceivedClick(items) {
    let {data} = this.state
    let checkItemnum = []
    items.forEach(function(item,index) {
      checkItemnum.push(item.bf_purchase_order_item_id)
    })
    data.forEach(function(item,index) {
      if (checkItemnum.indexOf(item.bf_purchase_order_item_id)!==-1) {
        data[index].is_receiveditem = true
      }
    })
    this.setState({data:data})
    this.savePODoc()
  }

  onAfterExportWorkClick(items) {
    let {data} = this.state
    let checkItemnum = []
    items.forEach(function(item,index) {
      checkItemnum.push(item.bf_purchase_order_item_id)
    })
    data.forEach(function(item,index) {
      if (checkItemnum.indexOf(item.bf_purchase_order_item_id)!==-1) {
        data[index].is_exportwork = true
      }
    })
    this.setState({data:data})
    this.savePODoc()
  }

  onAfterPOImportClick(items) {
    let {data} = this.state
    let checkItemnum = items.map((item,index)=> {
      return item.bf_purchase_order_item_id
    })
    data.forEach(function(item,index) {
      if (checkItemnum.indexOf(item.bf_purchase_order_item_id)!==-1) {
        data[index].is_importstock = true
      }
    })
    this.setState({data:data})
    this.savePODoc()
  }

  onAfterReturnClick(items) {
    let {data} = this.state
    let checkItemnum = []
    items.forEach(function(item,index) {
      checkItemnum.push(item.bf_purchase_order_item_id)
    })
    checkItemnum.forEach(function(item,index) {
      data.splice(data.map(function(e) { return e.bf_purchase_order_item_id; }).indexOf(item), 1)
    })
    this.setState({data:data})
    this.savePODoc()
  }

  onAutoCreateStockClick(items) {
    let {data} = this.state
    items.forEach((item,index)=>{
      const key = data.findIndex(x=>x.bf_purchase_order_item_id===item.bf_purchase_order_item_id)
      if (key!==-1) {
        data[key] = Object.assign(data[key], {itemnum:item.itemnum,stock_type:item.stock_type})
      }
    })
    this.setState({data:data})
    this.savePODoc()
  }

  onImgPOCheck(imgPO,img_po_from_cat) {
    this.setState({imgPO:imgPO,img_po_from_cat:img_po_from_cat})
  }

  renderImgZone() {
    let {dataImg} = this.state
    if (dataImg.files.length>0) {
      return(
        dataImg.files.map((item, index) => {
          return(
            <Col key={index} className="col-md-15 template-download">
              <div className="thumb-box">
                <span className="preview" onClick={this.onImgClick.bind(this,index)}>
                  <a title="">
                    <img alt='' src={item.thumbnailUrl} className='img-auto-width' />
                  </a>
                </span>
                <div style={{display:'flex'}}>
                  <p className="name">
                    <a>{item.name}</a>
                  </p>
                </div>
                <div className="footer-box" style={{display:'flex'}}>
                  {item.createddate}
                </div>
              </div>
            </Col>   
          )       
        })
      )    
    } else {
      return(
        <div className="text-center">
          {this.props.messages['No Image']}
        </div>
      )
    }  
  }

  renderPaymentVoucher() {
    let {showPaymentVoucher} = this.state
    return(
			<div>
				<Modal show={showPaymentVoucher} enforceFocus={false} onHide={()=>{this.setState({showPaymentVoucher:false})}} dialogClassName="fullwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>ใบสำคัญจ่าย</Modal.Title>
          </Modal.Header>
          <Modal.Body>
						<PaymentVoucherDoc
							ref='pvDoc' 
              title={'ใบสำคัญจ่าย'}
              docType={'paymentvoucher'}
              docSName={'pv'}
              docName={'paymentvoucher_doc'}
              poDocType={'purchaseorder'}
              onClose={()=>{this.setState({showPaymentVoucher:false})}}
            />
          </Modal.Body>
        </Modal>
			</div>
		)
  }

  render() {
    let { loading, show,showPOR,showPOT,showPOE,showPOI, showSaveEror,data ,doc,isPermApprovedDoc,po_config} = this.state
    let {is_user_po_approved_doc} = po_config
    let {messages} = this.props
    const {affiliates_id} = this.state.doc
    const title = (<span><FontAwesome name='list' />&nbsp;{messages['Choice']}</span>)
    
    let  showMenuItem = is_user_po_approved_doc ? (doc.status==="1" || doc.status=="2"|| doc.status=="3"|| doc.status=="4")  : true

    showMenuItem = (showMenuItem && doc.status!=='6')

    return (
      <div className='purchase-order-doc'>
      <Box loading={loading}>
        <Box.Header className='text-center'>
          <Box.Title>
            {messages['Orders']} {this.state.poNo} {this.renderStatus()} {this.renderPaymentStatus()}
          </Box.Title>          
          <Box.Tools className='pull-right'>
            <ButtonToolbar style={{display:'inline-flex'}}>
              <Button className='bg-maroon'
                onClick={this.onPrintClick.bind(this)}
              >
                <FontAwesome name='print' />&nbsp;{messages['Print Document']}
              </Button>
              &nbsp;
              <div style={{display:(doc.seq_no>0 && (isPermApprovedDoc || showMenuItem))?'': 'none'}}>
                <div className='purchase-order-dropdown'>
                  <DropdownButton bsStyle={'primary'} title={title} id={'po-menu-options'} onSelect={this.onMenuItemSelect.bind(this)}>
                    {isPermApprovedDoc && (<MenuItem eventKey="approvestatus" style={{display:(doc.status === '1' || doc.status === '2')?'none':''}}><FontAwesome name='thumbs-o-up' className='text-green' />&nbsp;{messages['Approved Item']}</MenuItem>)}
                    {isPermApprovedDoc && (<MenuItem eventKey="notapprovestatus" style={{display:(doc.status === '1' || doc.status === '2' || doc.status === '6')?'none':''}}><FontAwesome name='thumbs-o-down' />&nbsp;{messages['Not Approved Item']}</MenuItem>)}                    
                    {showMenuItem?<MenuItem divider />:''}                          
                    {showMenuItem?<MenuItem eventKey="receivestatus"><FontAwesome name='thumbs-o-up' className='text-black' />&nbsp;{messages['Received']}</MenuItem>:''}
                    {showMenuItem?<MenuItem eventKey="returnstatus"><FontAwesome name='thumbs-o-down' className='text-red' />&nbsp;{messages['Returns']}</MenuItem>:''}
                    {showMenuItem?<MenuItem divider />:''}
                    {showMenuItem?<MenuItem eventKey="exportworkstatus"><FontAwesome name='wrench' className='text-black' />&nbsp;{messages['Pickup']}</MenuItem>:''}
                    {showMenuItem?<MenuItem divider />:''}
                    {showMenuItem?<MenuItem eventKey="importstock"><FontAwesome name='industry' className='text-black' />&nbsp;{messages['Import Stock']}</MenuItem>:''}
                    {showMenuItem?<MenuItem divider />:''}
                    {showMenuItem?<MenuItem style={{display:(doc.payment_date !== '')?'none':''}} eventKey="paidstatus"><FontAwesome name='money' className='text-green' />&nbsp;{messages['Already Paid']}</MenuItem>:''}
                    {showMenuItem?<MenuItem eventKey="credit"><FontAwesome name='thumbs-o-up' className='text-black' />&nbsp;{messages['Credit']}</MenuItem>:''}
                    {showMenuItem?<MenuItem divider />:''}
                    {showMenuItem?<MenuItem eventKey="createnoreceive"><FontAwesome name='file-o' className='text-orange' />&nbsp;{messages['Create PO Not Received']}</MenuItem>:''}
                    {showMenuItem?<MenuItem eventKey="paymentvoucher"><FontAwesome name='file-o' className='text-red' />&nbsp;สร้างใบสำคัญจ่าย</MenuItem>:''}
                    {isPermApprovedDoc && (<MenuItem divider />)}
                    {isPermApprovedDoc && (<MenuItem eventKey="deletepo"><FontAwesome name='trash' className='text-red' />&nbsp;{messages['Delete Order Permanently']}</MenuItem>)}
                  </DropdownButton>
                </div>  
              </div>
              {this.props.closeButton && (<Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close'/></Button>)}
            </ButtonToolbar>
          </Box.Tools>
        </Box.Header>
        <Box.Body>
          <br/>
          {this.renderHeaderRow()}
          {this.renderTable()}
          {this.renderNewItemButton()}
          {this.renderRemark()}          
          <POOutstandingRecordModal show={showPOR} 
          onHide={()=>{this.setState({showPOR:false})}}
          data={data}
          doc={doc}
          recordType={'RECEIVED'}
          title={messages['Received']}
          onSavePORecord={this.onSavePORecord.bind(this,'RECEIVED')}
          onAfterReceivedClick={this.onAfterReceivedClick.bind(this)}
          />
          <POOutstandingRecordModal show={showPOT} 
          onHide={()=>{this.setState({showPOT:false})}}
          data={data}
          doc={doc}
          recordType={'RETURN'}
          title={messages['Returns']}
          onSavePORecord={this.onSavePORecord.bind(this,'RETURN')}
          onAfterReturnClick={this.onAfterReturnClick.bind(this)}
          />
          <POOutstandingRecordModal show={showPOE} 
          onHide={()=>{this.setState({showPOE:false})}}
          data={data}
          doc={doc}
          recordType={'EXPORTWORK'}
          title={messages['Pickup']}
          onSavePORecord={this.onSavePORecord.bind(this,'EXPORTWORK')}
          onAfterExportWorkClick={this.onAfterExportWorkClick.bind(this)}
          />
          <POOutstandingRecordModal show={showPOI} 
          onHide={()=>{this.setState({showPOI:false})}}
          data={data}
          doc={doc}
          recordType={'IMPORT_STOCK'}
          title={messages['Import Stock']}
          onSavePORecord={this.onSavePORecord.bind(this,'IMPORT_STOCK')}
          onAfterImportStockClick={this.onAfterPOImportClick.bind(this)}
          onAutoCreateStockClick={this.onAutoCreateStockClick.bind(this)}
          />
          <SupplierPageModal show={show} onHide={() => { this.setState({ show: false }) }}
            onSelect={this.onSupplierPageSelect.bind(this)}
          />
        </Box.Body>
        <Box.Footer>
          <ButtonToolbar className='pull-right'>
            <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;{messages['Save']}</Button>
            <Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close' />&nbsp;{messages['Close']}</Button>
          </ButtonToolbar>
        </Box.Footer>
        <ConfirmPopup show={showSaveEror} title={messages['Error']}
          confirmTitle={messages['Try Again']} cancelTitle={messages['Cancel']} message={messages['Error Please Try Again']}
          onConfirm={this.onSaveErrorConfirm.bind(this)}
          onHide={() => { this.setState({ showSaveEror: false }) }}
        />
        <Modal
          show={this.state.showReportWork && this.state.doc.shop_id !== null}
          onHide={this.closeReportWorkModal.bind(this)}
          dialogClassName="midwidth-dialog"
        >
          <Modal.Header closeButton>
            <Modal.Title>{messages['Select Parts From Worksheet']}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              // <ReportWork onRowWorkClick={this.onRowWorkClick.bind(this)} />
            }
            {
              <SelectParts
                shopId={this.state.doc.shop_id}
                purChaseOrders={this.state.data}
                // selectedPartItems={this.state.data.filter((item) => item.amount > 0)}
                onSavePartItemsClick={this.onSavePartItemsClick.bind(this)}
                onClose={this.closeReportWorkModal.bind(this)}
              />
            }
          </Modal.Body>
        </Modal>
        <NotificationSystem ref="notificationSystem" style={{
                                                      NotificationItem: { // Override the notification item
                                                        DefaultStyle: { // Applied to every notification, regardless of the notification level
                                                          margin: '10px 5px 2px 1px',
                                                          fontSize:'30px',
                                                          width:'600px',
                                                          textAlign:'center'
                                                        },
                                                      }
                                                    }}/> 
        <IframeModal ref='iframeUpload' title={messages['Upload Images']} modal={true} onUpImgHide={this.onUpImgHide.bind(this)}/>
        <SearchCarButton
          show={this.state.showCar}
          onHide={()=>{this.setState({showCar:false})}}
          onSelect={this.onCarSearchSelect.bind(this)}
          affId={affiliates_id}
          onAffChange={this.onAffChange.bind(this)}
        />
        <Lightbox
              currentImage={this.state.currentImage}
              images={this.state.images}
              isOpen={this.state.lightboxIsOpen}
              rotatable={true}
              zoomable={true}              
              onClickImage={this.onClickImage.bind(this)}
              onClickNext={this.onClickNext.bind(this)}
              onClickPrev={this.onClickPrevious.bind(this)}
              onClose={this.onCloseLightbox.bind(this)}
            />
      </Box>
      <Modal
          show={this.state.showWDA}
          onHide={this.onWDAHide.bind(this)}
          dialogClassName="fullwidth-dialog"
        >
          <Modal.Header closeButton>
            <Modal.Title>เลือกรูปเข้าไปในใบสั่งซื้อ</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <WorkDocAttachmentDoc
              workNo={this.state.doc.worklist}
              mode='po'
              onImgCheck={this.onImgPOCheck.bind(this)}
            />
          </Modal.Body>
          <Modal.Footer>
            <div className='pull-right'>
              <Button onClick={this.onUploadClick.bind(this)} bsStyle='primary'><FontAwesome name='file-image-o' />&nbsp;อับรูปโดยตรง</Button>
              <Button onClick={this.onAddPO.bind(this)} bsStyle='success'><FontAwesome name='plus' />&nbsp;เพิ่มรูปในใบสั่งซื้อ</Button>
              <Button onClick={this.onWDAHide.bind(this)}><FontAwesome name='close' />&nbsp;ปิด</Button>
            </div>
          </Modal.Footer>
      </Modal>     
      {this.renderPaymentVoucher()} 
      </div>
    )
  }
}

PurchaseOrderDoc.defaultProps = {
  newDocModal: false,
  itemList: [],
  closeButton:false
}

export default connect(
  (state) => ({messages: state.message.view.po.PurchaseOrderDoc}),null,null,{withRef:true}
)(PurchaseOrderDoc);





// WEBPACK FOOTER //
// ./src/view/po/PurchaseOrderDoc.js